<template>
  <el-dialog
    v-loading="isLoading"
    title="拣货"
    :visible.sync="dialogFormVisible"
    width="60vw"
    height="100vh"
    top="2vh"
    :fullscreen="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="库位编号">
        <el-input v-model.trim="form.positionNum"></el-input>
      </el-form-item>
      <el-form-item  label="物品编号">
        <el-input v-model.trim="form.itemNo"></el-input>
      </el-form-item>
    </el-form>
     <el-table v-loading="listLoading" :data="tableData" border style="width: 100%" :cell-style="setRowStyle">
      <!-- 拣货状态 -->
      <el-table-column align="center" label="拣货状态">
        <template slot-scope="{ row }">
          <div v-if="row.status == 1">待拣货</div>
          <div v-if="row.status == 2">拣货完成</div>
        </template>
      </el-table-column>
      <!-- 任务编号-->
      <el-table-column align="center" prop="carContainerCode" label="任务编号" />
      <!-- 所在库位 -->
      <el-table-column align="center" prop="positionNum" label="所在库位" />
      <!-- 商品编号 -->
      <el-table-column align="center" prop="itemNo" label="商品编号" />
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { task_picking, buyStatus, buyUpdate } from '@/api/xgcApi'
  export default {
    name: 'UserManagementEdit',
    components: {},
    data() {
      return {
        form: {},
        title: '',
        listLoading: false, // 请求数据加载
        srcList: [],
          tableData: [],
        dialogFormVisible: false,
        isLoading: false,
        rules: {
          price: [
            { required: true, trigger: 'blur', message: '请输入物品金额' },
          ],
        },
        daifu: false,
        statusList: [
          {
            value: 0,
            label: '待审核',
          },
          {
            value: 1,
            label: '待支付',
          },

          {
            value: 2,
            label: '代采购',
          },
          {
            value: 8,
            label: '已采购',
          },
          {
            value: 3,
            label: '已入库',
          },
          {
            value: 5,
            label: '已取消',
          },
          {
            value: 6,
            label: '退款中',
          },
          {
            value: 7,
            label: '已退款',
          },
          {
            value: 9,
            label: '已驳回',
          },
        ],
      }
    },

    created() {},
    methods: {
            // 根据条件设置样式，例如改变背景色和字体颜色等。
    setRowStyle({ row, rowIndex }) {
      if (row.status == 0) {
        return {
          backgroundColor: '#ffff7f'
        }
      } else if (row.status == 2) {
        return {
          backgroundColor: '#55ff7f'
        }
      } else {
        return {
          backgroundColor: ''
        }
      }
    },
      handleInputPrice() {
        // 移除非数字和非小数点字符，保留小数点
        this.form.price = this.form.price
          .replace(/[^\d.]/g, '')
          // 保留第一个小数点，移除其他小数点
          .replace(/^(\d*\.)(.*)\./g, '$1$2')
          // 移除前导零，但保留小数点前的单个零
          .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
      },

      async showEdit(row) {
        if (row.type == 2) {
          this.daifu = true
        } else {
          this.daifu = false
        }
        this.srcList = []
        this.dialogFormVisible = true
        this.title = '编辑'
        const { data } = await task_picking({ kor_type:0,task_code:row.task_code })
        this.form = data
        if (data.pic != null) {
          const chars = data.pic.split(',')
          this.srcList = chars
        }
      },

      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            const { msg } = await buyUpdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style scoped>
  :deep .el-select > .el-input {
    width: 430px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
